import { api } from "@/api";
import { ApiError } from "@/types";
import { escapeHtml } from "@/utils";

function render(container: HTMLElement, html: string): void {
  container.innerHTML = html;
}

function renderMissingToken(container: HTMLElement): void {
  render(container, `
    <div class="stack">
      <div class="form-error">缺少验证链接，请重新打开邮件中的完整链接。</div>
      <div class="modal-actions">
        <a class="primary-button" href="/login/">去登录</a>
        <a class="ghost-button" href="/register/">重新注册</a>
      </div>
    </div>
  `);
}

function renderSuccess(container: HTMLElement, email: string): void {
  render(container, `
    <div class="stack">
      <div class="notice-success">
        邮箱验证成功${email ? `：<code>${escapeHtml(email)}</code>` : ""}。现在可以登录并领取注册权益了。
      </div>
      <div class="modal-actions">
        <a class="primary-button" href="/login/?verified=1&email=${encodeURIComponent(email)}">去登录</a>
      </div>
    </div>
  `);
}

function renderError(container: HTMLElement, error: ApiError): void {
  const message = (() => {
    switch (error.code) {
      case "EMAIL_VERIFICATION_EXPIRED":
        return "验证链接已过期，请回到登录页重新发送验证邮件。";
      case "EMAIL_VERIFICATION_USED":
        return "该验证链接已使用，可以直接登录。";
      case "EMAIL_VERIFICATION_INVALID":
        return "验证链接无效，请确认链接完整，或重新发送验证邮件。";
      default:
        return error.message || "邮箱验证失败，请稍后重试。";
    }
  })();

  render(container, `
    <div class="stack">
      <div class="form-error">${escapeHtml(message)}</div>
      <div class="modal-actions">
        <a class="primary-button" href="/login/">去登录</a>
        <a class="ghost-button" href="/register/">返回注册</a>
      </div>
    </div>
  `);
}

export async function initVerifyEmailPage(): Promise<void> {
  const container = document.querySelector<HTMLElement>("#verifyEmailContent");
  if (!container) return;

  const token = new URLSearchParams(window.location.search).get("token")?.trim() || "";
  if (!token) {
    renderMissingToken(container);
    return;
  }

  try {
    const data = await api<{ member?: { email?: string | null } }>(`/api/auth/verify-email?token=${encodeURIComponent(token)}`);
    renderSuccess(container, data.member?.email || "");
  } catch (error) {
    renderError(container, error as ApiError);
  }
}
